module.exports = __webpack_public_path__ + "img/015-checked.e2ca1c0d.svg";